import React from "react"
import { SpeedButton, SpeedSelectorUI } from "./ui"

const SpeedSelector = ({
  speedOptions = [1, 1.5, 2, 3, 0.5],
  currentSpeed: propsCurrentSpeed = 1,
  onSelectSpeed
}: {
  speedOptions?: number[]
  currentSpeed?: number
  onSelectSpeed: (speed: number) => void
}) => {

  const [currentSpeed, setCurrentSpeed] = React.useState(propsCurrentSpeed)

  // Allow speed to be changed from parent sources
  React.useEffect(() => {
    setCurrentSpeed(propsCurrentSpeed)
  }, [propsCurrentSpeed])

  const handleSetSpeed = () => {
    const speedIndex = speedOptions.indexOf(Number(currentSpeed))

    const nextSpeed =
      speedIndex >= speedOptions.length - 1
        ? speedOptions[0]
        : speedOptions[speedIndex + 1]

    setCurrentSpeed(nextSpeed)
    onSelectSpeed(nextSpeed)
  }

  return (
    <SpeedSelectorUI>
      <SpeedButton onClick={handleSetSpeed}>{`${currentSpeed}x`}</SpeedButton>
    </SpeedSelectorUI>
  )
}

export default SpeedSelector
